import { apiClient } from './client';

// docs/work_log/v1032-remaining-work-batch-13 §5 — UI 의 PII-관련 toggle event 를
// 서버측 AuditLog 로 기록하는 client wrapper.
//
// Fire-and-forget: 실패해도 UI 흐름을 막지 않음 (UX 우선). 실패는 console 에만
// 출력 — 운영자가 토글을 일상적으로 쓰는 동안 toast 가 뜨면 시끄러움.

export type ClientAuditAction = 'ui.inbox.reporter_phone_visibility.toggle';

export interface ClientAuditEvent {
  action: ClientAuditAction;
  resourceType?: string;
  resourceId?: string;
  metadata?: { newState?: 'on' | 'off' };
}

export const auditEventsApi = {
  /** POST /audit-logs/client-event — fire-and-forget. */
  async record(event: ClientAuditEvent): Promise<void> {
    try {
      await apiClient.post('/audit-logs/client-event', event);
    } catch (err) {
      // UX 우선 — UI flow 막지 않음.
      console.warn('[audit-events] failed to record:', err);
    }
  },
};
